// extracted by mini-css-extract-plugin
export default {"wrapper":"deleteReportDialog_wrapper__+kQ2i","message":"deleteReportDialog_message__8iVFE","buttons":"deleteReportDialog_buttons__8UC5n","loader":"deleteReportDialog_loader__7jqvP"};